import { selectSelectedRowIds } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useSelectedRowIds(): Set<string> {
  return useEagGridSelector(selectSelectedRowIds);
}